import React from 'react';
import { Column, ColumnContent, IColumnProps } from './Column';
import { withTranslate } from '../../../../../shared/i18n/translate';
import { ColumnHeader } from '../../../../overview/ui/list/item/Column';

interface IBaggageClaimProps extends IColumnProps {
	baggageClaim: string;
}

export const BaggageClaimColumn = withTranslate<IBaggageClaimProps>(
	({ t, baggageClaim, columns }) => (
		<Column columns={columns}>
			<ColumnHeader>{t('flight_details_baggage_claim')}</ColumnHeader>
			<ColumnContent>{baggageClaim}</ColumnContent>
		</Column>
	),
);
